import {Theme, createStyles} from '@material-ui/core';

export const formSubmitModalStyles = (theme: Theme) =>
	createStyles({
		modal: {
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
		},
		paper: {
			display: 'flex',
			backgroundColor: theme.palette.primary.main,
			boxShadow: theme.shadows[5],
			padding: theme.spacing(15, 20, 0),
			[theme.breakpoints.down('sm')]: {
				flexDirection: 'column-reverse',
				alignItems: 'center',
				padding: theme.spacing(6, 7, 0),
			},
			'&:focus': {
				outline: 'unset',
			},
		},
		title: {
			textTransform: 'uppercase',
			fontSize: 42,
			color: theme.palette.background.default,
			marginBottom: theme.spacing(2),
			[theme.breakpoints.down('sm')]: {
				fontSize: 18,
				marginBottom: theme.spacing(1),
			},
		},
		description: {
			color: theme.palette.text.light,
			fontSize: 16,
			whiteSpace: 'break-spaces',
			[theme.breakpoints.down('sm')]: {
				fontSize: 10,
			},
		},
		textBlock: {
			display: 'flex',
			flexDirection: 'column',
			justifyContent: 'center',
			marginBottom: theme.spacing(18),
			[theme.breakpoints.down('sm')]: {
				textAlign: 'center',
				marginBottom: theme.spacing(0),
			},
		},
		imageBlock: {
			display: 'flex',
			marginRight: theme.spacing(8),
			'& img': {
				[theme.breakpoints.down('sm')]: {
					height: 213,
				},
			},
			[theme.breakpoints.down('sm')]: {
				marginRight: 0,
				minHeight: 'unset',
				minWidth: 'unset',
			},
		},
		backToHome: {
			fontSize: 12,
			color: theme.palette.secondary.main,
			textTransform: 'uppercase',
			borderColor: theme.palette.secondary.main,
			marginTop: theme.spacing(6),
			'&.MuiButton-outlinedPrimary:hover': {
				borderColor: theme.palette.secondary.main,
			},
			[theme.breakpoints.down('sm')]: {
				marginBottom: theme.spacing(4),
				marginTop: theme.spacing(3),
				fontSize: 10,
			},
		},
	});
